module.exports = __webpack_public_path__ + "static/media/islandHomes.67cb2db2.svg";